import { Box, Typography } from "@mui/material";
import { textXS } from "../../../../shared/constants";
import { PriorityParameterGuids } from "../../../../constants/parameterGuids";
import { useWiserTheme } from "../../../../hooks/useWiserTheme";
import { getPriorityTagColors } from "../../../../shared/theme/wiserThemeHelpers";
import { getTagChipSx } from "../../style";

const getPriorityLabel = (priorityId?: string | null) => {
    const id = String(priorityId ?? "").toLowerCase();
    switch (id) {
        case PriorityParameterGuids.high:
            return "Yüksek Öncelikli";
        case PriorityParameterGuids.medium:
            return "Orta Öncelikli";
        case PriorityParameterGuids.low:
            return "Düşük Öncelikli";
        default:
            return "Öncelik Belirlenmedi";
    }
};

export const PriorityTag = ({ priority }: { priority?: string | number | null }) => {
    const { darkModeActive } = useWiserTheme();
    const priorityId = typeof priority === "number" ? null : String(priority ?? "").toLowerCase();
    // Renkler paylasilan yardimcidan: ISIKLI dali eski yerel switch ile
    // birebir ayni, ek olarak koyu tema tonlarini tasiyor. Etiket metni
    // Guid'e gore burada uretiliyor (upstream legacy int id kullaniyor).
    const priorityColors = getPriorityTagColors(priorityId, darkModeActive);
    const priorityLabel = getPriorityLabel(priorityId);
    return (
        <Box sx={getTagChipSx(priorityColors.bg)}>
            <Typography sx={textXS(500, priorityColors.text)}>
                {priorityLabel}
            </Typography>
        </Box>
    );
};
